exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3iZkq{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin:10px 0}._wg-LX{display:inline-block;padding-left:0;border-radius:4px;margin:0 5px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._wg-LX>li{display:inline}._wg-LX>li>span{position:relative;float:left;padding:6px 12px;line-height:20px;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px;cursor:pointer}._wg-LX>li:first-child>span{margin-left:0}._wg-LX>li>span:focus,._wg-LX>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}._wg-LX>._2fP21>span,._wg-LX>._2fP21>span:focus,._wg-LX>._2fP21>span:hover{z-index:3;color:#23527c;background-color:#eee;border-color:#ddd;cursor:default}._vRJTd{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;color:#23527c;outline:none;cursor:pointer}._vRJTd:hover{color:#337ab7;background-color:#eee;border-color:#ddd}", ""]);

// exports
exports.locals = {
	"pagination": "_3iZkq",
	"pages": "_wg-LX",
	"active": "_2fP21",
	"button": "_vRJTd"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=_[hash:base64:5]!./~/postcss-loader!./~/autoprefixer-loader!./~/less-loader!./lib/Pager.less
// module id = 15
// module chunks = 0